var $f59f1e3aec311175$exports = {};
$f59f1e3aec311175$exports = import.meta.resolve("aB7Az");


var $262a9968106876f1$exports = {};
$262a9968106876f1$exports = import.meta.resolve("c4N9f");


var $c9c56554b0e7dc83$exports = {};
$c9c56554b0e7dc83$exports = import.meta.resolve("fzr1I");


var $3bc306db4b479e0d$exports = {};
$3bc306db4b479e0d$exports = import.meta.resolve("9GnI3");


var $3981e8b08b488656$exports = {};
$3981e8b08b488656$exports = import.meta.resolve("bHLj6");


var $626c7a2fa2af951c$exports = {};
$626c7a2fa2af951c$exports = import.meta.resolve("gmpQy");


var $457af8793070a599$exports = {};
$457af8793070a599$exports = import.meta.resolve("23u8k");


var $40783fad3df3dfeb$exports = {};
$40783fad3df3dfeb$exports = import.meta.resolve("gUPj7");


var $36543a1ce7d132a7$exports = {};
$36543a1ce7d132a7$exports = import.meta.resolve("4iVrc");


var $45015e6134314250$exports = {};
$45015e6134314250$exports = import.meta.resolve("eTxaT");


var $5235a35d565c0f60$exports = {};
$5235a35d565c0f60$exports = import.meta.resolve("59uOW");


var $f67786dedb7a1eee$exports = {};
$f67786dedb7a1eee$exports = import.meta.resolve("9ouat");


const $6ce733342529a65e$export$79863f625c4e57 = [
    {
        id: 1,
        img: new URL($f59f1e3aec311175$exports).href,
        // video: new URL("../videos/cyberpunk.mp4", import.meta.url).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766510485/cyberpunk_leuluu.mp4",
        title: "Cyberpunk 2077",
        price: 2999,
        ratings: 4.6,
        platform: [
            "PC",
            "|",
            "PS5",
            "|",
            "XBOX"
        ],
        iswishlist: false,
        type: [
            "action",
            "fav"
        ],
        description: "Cyberpunk 2077 drops you into Night City, a neon-soaked world where tech upgrades your body and choices shape your legend.",
        copiessold: "Sold ~35 Million+ copies worldwide",
        store: "https://store.steampowered.com/app/1091500/Cyberpunk_2077/"
    },
    {
        id: 2,
        img: new URL($262a9968106876f1$exports).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766513776/detroit_elvmmm.mp4",
        title: "Detroit Became Human",
        price: 2499,
        ratings: 4.8,
        platform: [
            "PC",
            "|",
            "PS5"
        ],
        iswishlist: false,
        type: [
            "story",
            "fav"
        ],
        description: "Detroit: Become Human explores a near future where androids question their purpose\u2014and their humanity.",
        copiessold: "Sold ~11 Million+ copies worldwide",
        store: "https://store.steampowered.com/app/1222140/Detroit_Become_Human/"
    },
    {
        id: 3,
        img: new URL($c9c56554b0e7dc83$exports).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766788570/gow4_hge2nw.mp4",
        title: "God Of War 2018",
        price: 2199,
        ratings: 4.7,
        platform: [
            "PC",
            "|",
            "PS5",
            "|",
            "XBOX"
        ],
        iswishlist: false,
        type: [
            "story"
        ],
        description: "God of War reimagines the legend\u2014an epic journey of gods, monsters, and a father learning to be human.",
        copiessold: "Sold ~23 Million+ copies worldwide",
        store: "https://store.steampowered.com/app/1593500/God_of_War/"
    },
    {
        id: 4,
        img: new URL($3bc306db4b479e0d$exports).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766518866/gow5_l7nkbh.mp4",
        title: "God Of War Ragnarok",
        price: 2999,
        ratings: 5,
        platform: [
            "PC",
            "|",
            "PS5",
            "|",
            "XBOX"
        ],
        iswishlist: false,
        type: [
            "story",
            "fav"
        ],
        description: "God of War Ragnar\xf6k follows Kratos and Atreus as they journey through the Nine Realms, facing gods, monsters, and the coming of Ragnar\xf6k.",
        copiessold: "Sold ~15 Million+ copies worldwide",
        store: "https://store.steampowered.com/app/2322010/God_of_War_Ragnark/"
    },
    {
        id: 5,
        img: new URL($3981e8b08b488656$exports).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766519575/gta5_gnhngt.mp4",
        title: "Grand Theft Auto 5",
        price: 1599,
        ratings: 4.5,
        platform: [
            "PC",
            "|",
            "PS5",
            "|",
            "XBOX"
        ],
        iswishlist: false,
        type: [
            "story",
            "action"
        ],
        description: "Grand Theft Auto V follows three criminals navigating crime, chaos, and ambition in the sprawling city of Los Santos.",
        copiessold: "Sold ~220 Million+ copies worldwide",
        store: "https://store.steampowered.com/app/271590/Grand_Theft_Auto_V/"
    },
    {
        id: 6,
        img: new URL($626c7a2fa2af951c$exports).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766519873/last-of-us1_uziutr.mp4",
        title: "The Last Of Us Part 1",
        price: 2799,
        ratings: 4.8,
        platform: [
            "PC",
            "|",
            "PS5"
        ],
        iswishlist: false,
        type: [
            "story"
        ],
        description: "The Last of Us follows Joel and Ellie as they journey across a broken world, fighting to survive and protect what remains.",
        copiessold: "Sold ~17 Million+ copies worldwide",
        store: "https://store.steampowered.com/app/1888930/The_Last_of_Us_Part_I/"
    },
    {
        id: 7,
        img: new URL($457af8793070a599$exports).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766520589/last-of-us2_hu7s6m.mp4",
        title: "The Last Of Us Part 2",
        price: 2999,
        ratings: 5,
        platform: [
            "PC",
            "|",
            "PS5"
        ],
        iswishlist: false,
        type: [
            "story",
            "fav"
        ],
        description: "Step into a world reclaimed by nature, where every shadow hides danger, every fight is a test, and your choices shape Ellie\u2019s journey.",
        copiessold: "Sold ~10 Million+ copies worldwide",
        store: "https://store.steampowered.com/app/2531310/The_Last_of_Us_Part_II_Remastered/"
    },
    {
        id: 8,
        img: new URL($40783fad3df3dfeb$exports).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766788391/little-nightmares2_xaclm7.mp4",
        title: "Little Nightmares 2",
        price: 1599,
        ratings: 4.5,
        platform: [
            "PC",
            "|",
            "PS5"
        ],
        iswishlist: false,
        type: [
            "horror"
        ],
        description: "Little Nightmares II plunges you into a creepy, twisted world where shadows hide monsters, and every corner hides a new danger.",
        copiessold: "Sold ~3 Million+ copies worldwide",
        store: "https://store.steampowered.com/app/860510/Little_Nightmares_II/"
    },
    {
        id: 9,
        img: new URL($36543a1ce7d132a7$exports).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766788393/rdr2_jjqwtv.mp4",
        title: "Red Dead Redemption 2",
        price: 2999,
        ratings: 4.8,
        platform: [
            "PC",
            "|",
            "PS5",
            "|",
            "XBOX"
        ],
        iswishlist: false,
        type: [
            "story"
        ],
        description: "Ride across mountains, rivers, and towns, hunt, rob, and live the life of an outlaw in a breathtakingly detailed open world.",
        copiessold: "Sold ~79 Million+ copies worldwide",
        store: "https://store.steampowered.com/app/1174180/Red_Dead_Redemption_2/"
    },
    {
        id: 10,
        img: new URL($45015e6134314250$exports).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766788427/spiderman-miles_avi3gs.mp4",
        title: "Spider-Man Miles Morales",
        price: 2899,
        ratings: 4.7,
        platform: [
            "PC",
            "|",
            "PS5",
            "|",
            "XBOX"
        ],
        iswishlist: false,
        type: [
            "action",
            "fav"
        ],
        description: "Spider-Man: Miles Morales swings you through a vibrant, snowy New York as Miles discovers his powers and what it truly means to be a hero.",
        copiessold: "Sold ~8 Million+ copies worldwide",
        store: "https://store.steampowered.com/app/1817190/Marvels_SpiderMan_Miles_Morales/"
    },
    {
        id: 11,
        img: new URL($5235a35d565c0f60$exports).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766788353/stray_pjli0z.mp4",
        title: "Stray",
        price: 1299,
        ratings: 4.5,
        platform: [
            "PC",
            "|",
            "PS5",
            "|",
            "XBOX"
        ],
        iswishlist: false,
        type: [
            "story"
        ],
        description: "Stray lets you explore a neon-lit, futuristic city as a stray cat, solving puzzles, sneaking past dangers, and uncovering a mysterious world.",
        copiessold: "Sold ~6 Million+ copies worldwide",
        store: "https://store.steampowered.com/app/1332010/Stray/"
    },
    {
        id: 12,
        img: new URL($f67786dedb7a1eee$exports).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766788643/rise-of-the-tomb-raider_s0lbbg.mp4",
        title: "Rise Of The Tomb Raider",
        price: 2899,
        ratings: 4.7,
        platform: [
            "PC",
            "|",
            "PS5",
            "|",
            "XBOX"
        ],
        iswishlist: false,
        type: [
            "action",
            "fav"
        ],
        description: "Explore vast landscapes, solve intricate puzzles, and master combat as Lara evolves from survivor to legend.",
        copiessold: "Sold ~10 Million+ copies worldwide",
        store: "https://store.steampowered.com/app/391220/Rise_of_the_Tomb_Raider/"
    }
];


const $2b6e161c9edcf319$var$homeImg = document.querySelector(".home-img");
const $2b6e161c9edcf319$var$noGameDiv = document.querySelector(".no-games-div");
const $2b6e161c9edcf319$var$parent = document.querySelector(".home-div-1");
const $2b6e161c9edcf319$var$search = document.querySelector(".top-bar-search");
const $2b6e161c9edcf319$var$homeBtn = document.querySelector(".top-bar-p-home");
const $2b6e161c9edcf319$var$recommendationsBtn = document.querySelector(".top-bar-p-recommendations");
const $2b6e161c9edcf319$var$recommendModal = document.querySelector(".recommendations-modal");
const $2b6e161c9edcf319$var$wishlistBtn = document.querySelector(".top-bar-p-wishlist");
const $2b6e161c9edcf319$var$catDiv = document.querySelector(".categories-div");
const $2b6e161c9edcf319$var$catDivInner = document.querySelector(".categories");
const $2b6e161c9edcf319$var$allBtn = document.querySelector(".active-a");
const $2b6e161c9edcf319$var$catBtn = document.querySelectorAll(".categories-1");
let $2b6e161c9edcf319$var$wishlistArray = JSON.parse(localStorage.getItem("wishlistArray")) || [];
function $2b6e161c9edcf319$var$getRating(ratings) {
    return ratings >= 4.8 ? "\u2B50\u2B50\u2B50\u2B50\u2B50 5 Star" : ratings >= 4.7 ? "\u2B50\u2B50\u2B50\u2B50 4 Star" : ratings >= 4.6 ? "\u2B50\u2B50\u2B50 3 Star" : ratings >= 4.5 ? "\u2B50\u2B50 2 Star" : ratings >= 4.4 ? "\u2B50 1 Star" : "No ratings";
}
function $2b6e161c9edcf319$var$render(game, delay = 0) {
    const isWishlisted = $2b6e161c9edcf319$var$wishlistArray.includes(game.id);
    const wishlistText = isWishlisted ? "Wishlisted \u2705" : "Wishlist \u2764\uFE0F";
    const html = `
    
            <div class="game-card" style="animation-delay:${delay}ms">
        <div class="home-div-2" data-id=${game.id}>
                <img draggable="false" class="card-img-1"  src="${game.img}">
                <div class="card-p-1 cp1">
                <div class="card-p-a card-p-a-1-1">
                    <p class="card-p-1 card-p-1-title">${game.title}</p>
                </div>
                <div class="card-p-a-1">
                    <p class="card-p-1">Price:</p>
                    <p class="card-p-1">\u{20B9} ${game.price}</p>
                </div>

                <div class="card-p-a card-p-a-1">
                    <p class="card-p-1">Ratings:</p>
                    <p class="card-p-1">${$2b6e161c9edcf319$var$getRating(game.ratings)}</p>
                </div>

                <div class="card-p-a card-p-a-1">
                    <p class="card-p-1">Genre:</p>
                    <div class="card-p-a-3">
                        ${game.type.filter((pp)=>pp !== "fav").map((p)=>`<p class="card-p-1">${p}</p>`).join("")}
                    </div>
                </div>
                
                <div class="card-p-a card-p-a-1">
                    <p class="card-p-1 ao">Available on:</p>
                    <div class="card-p-a-3">
                        ${game.platform.map((p)=>`<p class="card-p-1 ao">${p}</p>`).join("")}
                    </div>
                </div>

                
                
                <div class="game-details hidden">
                <video class="modal-video" controls>${game.video}</video>
                <div class="game-details-2">
                <p class="details-title">${game.title}</p>
                <p class="details-desc">${game.description}</p>
                <p class="details-copiessold">${game.copiessold}</p>
                <p class="details-close">Close \u{2716}</p>
                </div>
                </div>
                
                </div>

                <div class="card-p-a card-p-a-4">
                    <p class="card-p-1 card-p-last card-p-view">view</p>
                    <p class="card-p-1 card-p-last card-p-wishlist">${wishlistText}</p>
                    <p class="card-p-1 card-p-last card-p-buy">Buy Now</p>
                    <a href="${game.store}" target="_blank"><p class="card-p-buy">Visit the game!</p></a>
                </div>
            </div>
        </div>
                
    `;
    $2b6e161c9edcf319$var$parent.insertAdjacentHTML("beforeend", html);
}
const $2b6e161c9edcf319$var$gamesLoad = function() {
    $2b6e161c9edcf319$var$parent.innerHTML = "";
    (0, $6ce733342529a65e$export$79863f625c4e57).forEach((game, index)=>{
        $2b6e161c9edcf319$var$render(game, index * 120);
    });
};
$2b6e161c9edcf319$var$gamesLoad();
$2b6e161c9edcf319$var$search.addEventListener("input", (e)=>{
    const query = e.target.value.toLowerCase();
    // console.log(query);
    $2b6e161c9edcf319$var$catDivInner.classList.remove("hidden");
    const msg = $2b6e161c9edcf319$var$catDiv.querySelector(".wishlist-header");
    if (msg) msg.remove();
    $2b6e161c9edcf319$var$wishlistBtn.classList.remove("active-2");
    $2b6e161c9edcf319$var$recommendationsBtn.classList.remove("active-2");
    $2b6e161c9edcf319$var$recommendModal.classList.add("hidden");
    $2b6e161c9edcf319$var$homeBtn.classList.remove("active-2");
    $2b6e161c9edcf319$var$catBtn.forEach((btn)=>btn.classList.remove("active"));
    if (query === "") {
        const msg = $2b6e161c9edcf319$var$catDiv.querySelector(".wishlist-header");
        if (msg) msg.remove();
        $2b6e161c9edcf319$var$wishlistBtn.classList.remove("active-2");
        $2b6e161c9edcf319$var$recommendationsBtn.classList.remove("active-2");
        $2b6e161c9edcf319$var$recommendModal.classList.add("hidden");
        $2b6e161c9edcf319$var$homeBtn.classList.add("active-2");
        $2b6e161c9edcf319$var$allBtn.classList.add("active");
    // renderGames(games);
    }
    const filteredGames = (0, $6ce733342529a65e$export$79863f625c4e57).filter((game)=>game.title.toLowerCase().includes(query));
    // console.log(filteredGames);
    $2b6e161c9edcf319$var$renderGames(filteredGames);
});
function $2b6e161c9edcf319$var$renderGames(gamesArray) {
    $2b6e161c9edcf319$var$parent.innerHTML = "";
    $2b6e161c9edcf319$var$noGameDiv.innerHTML = "";
    const html2 = `
    <p class="no-game-p" style="text-align: center; font-size: 20px; color: white;">No Games Found!!!!</p>`;
    if (gamesArray.length === 0) $2b6e161c9edcf319$var$noGameDiv.insertAdjacentHTML("beforeend", html2);
    //     gamesArray.forEach(game => {
    //     render(game);
    // });
    gamesArray.forEach((game, index)=>{
        $2b6e161c9edcf319$var$render(game, index * 120);
    });
}
$2b6e161c9edcf319$var$homeBtn.addEventListener("click", (e)=>{
    $2b6e161c9edcf319$var$search.value = "";
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
    if ($2b6e161c9edcf319$var$homeBtn.classList.contains("active-2")) return;
    $2b6e161c9edcf319$var$catDiv.classList.remove("hidden");
    $2b6e161c9edcf319$var$catDivInner.classList.remove("hidden");
    const msg = $2b6e161c9edcf319$var$catDiv.querySelector(".wishlist-header");
    if (msg) msg.remove();
    $2b6e161c9edcf319$var$recommendModal.classList.add("hidden");
    $2b6e161c9edcf319$var$recommendationsBtn.classList.remove("active-2");
    $2b6e161c9edcf319$var$wishlistBtn.classList.remove("active-2");
    $2b6e161c9edcf319$var$homeBtn.classList.add("active-2");
    $2b6e161c9edcf319$var$catBtn.forEach((btn)=>{
        btn.classList.remove("active");
    });
    $2b6e161c9edcf319$var$catBtn[0]?.classList.add("active");
    $2b6e161c9edcf319$var$renderGames((0, $6ce733342529a65e$export$79863f625c4e57));
});
$2b6e161c9edcf319$var$catBtn.forEach((btn)=>{
    btn.addEventListener("click", ()=>{
        $2b6e161c9edcf319$var$search.value = "";
        $2b6e161c9edcf319$var$noGameDiv.innerHTML = "";
        const type = btn.dataset.category;
        console.log(type);
        const catFilterGame = type === "all" ? (0, $6ce733342529a65e$export$79863f625c4e57) : (0, $6ce733342529a65e$export$79863f625c4e57).filter((g)=>g.type.includes(type));
        console.log(catFilterGame);
        if (btn.classList.contains("active")) return;
        $2b6e161c9edcf319$var$catBtn.forEach((b)=>b.classList.remove("active"));
        btn.classList.add("active");
        $2b6e161c9edcf319$var$parent.innerHTML = "";
        catFilterGame.forEach((game, index)=>{
            $2b6e161c9edcf319$var$render(game, index * 120);
        });
    });
});
$2b6e161c9edcf319$var$parent.addEventListener("click", (e)=>{
    if (!e.target.classList.contains("card-p-buy")) return;
    // const card = e.target.closest(".home-div-2");
    const btn = e.target;
    // if(card.querySelector(".buy-msg")) return;
    const originalText = btn.textContent;
    // const msg = document.createElement("p");
    // msg.className = "buy-msg";
    // msg.textContent = "Will add this option soon!!";
    // msg.style.color = "white";
    // msg.style.fontSize = "20px";
    btn.textContent = "Soon.....";
    btn.style.pointerEvents = "none";
    btn.style.opacity = "0.7";
    // card.appendChild(msg);
    setTimeout(()=>{
        btn.textContent = originalText;
        btn.style.pointerEvents = "auto";
        btn.style.opacity = "1";
    // card.removeChild(msg);
    }, 1500);
});
$2b6e161c9edcf319$var$parent.addEventListener("click", (e)=>{
    if (!e.target.classList.contains("card-p-wishlist")) return;
    const card = e.target.closest(".home-div-2");
    const gameId = Number(card.dataset.id);
    if ($2b6e161c9edcf319$var$wishlistArray.includes(gameId)) {
        $2b6e161c9edcf319$var$wishlistArray = $2b6e161c9edcf319$var$wishlistArray.filter((id)=>id !== gameId);
        e.target.textContent = "Wishlist \u2764\uFE0F";
    } else {
        $2b6e161c9edcf319$var$wishlistArray.push(gameId);
        e.target.textContent = "Wishlisted \u2705";
    }
    localStorage.setItem("wishlistArray", JSON.stringify($2b6e161c9edcf319$var$wishlistArray));
});
function $2b6e161c9edcf319$var$renderWishlistGames(gamesArray) {
    $2b6e161c9edcf319$var$parent.innerHTML = "";
    $2b6e161c9edcf319$var$noGameDiv.innerHTML = "";
    const html2 = `
    <p class="no-game-p" style="text-align: center; font-size: 20px; color: white;">No Wishlists!!!</p>`;
    if (gamesArray.length === 0) $2b6e161c9edcf319$var$noGameDiv.insertAdjacentHTML("beforeend", html2);
    gamesArray.forEach((game, index)=>{
        $2b6e161c9edcf319$var$render(game, index * 120);
    });
}
var $53eb862710d176c8$exports = {};
$53eb862710d176c8$exports = import.meta.resolve("2a1AK");


function $2b6e161c9edcf319$var$showWishlist() {
    $2b6e161c9edcf319$var$search.value = "";
    if ($2b6e161c9edcf319$var$wishlistBtn.classList.contains("active-2")) return;
    $2b6e161c9edcf319$var$recommendModal.classList.add("hidden");
    $2b6e161c9edcf319$var$homeBtn.classList.remove("active-2");
    $2b6e161c9edcf319$var$recommendationsBtn.classList.remove("active-2");
    $2b6e161c9edcf319$var$wishlistBtn.classList.add("active-2");
    $2b6e161c9edcf319$var$catDivInner.classList.add("hidden");
    const oldWrapper = $2b6e161c9edcf319$var$catDiv.querySelector(".wishlist-header");
    if (oldWrapper) oldWrapper.remove();
    const wrapper = document.createElement("div");
    wrapper.className = "wishlist-header";
    const img = document.createElement("img");
    img.src = new URL($53eb862710d176c8$exports).href;
    img.alt = "wishlist";
    img.className = "wishlist-icon";
    const msg = document.createElement("p");
    msg.className = "buy-msg";
    msg.textContent = "Wishlisted Games";
    wrapper.appendChild(msg);
    wrapper.appendChild(img);
    $2b6e161c9edcf319$var$catDiv.appendChild(wrapper);
    const wishlistedGames = (0, $6ce733342529a65e$export$79863f625c4e57).filter((game)=>$2b6e161c9edcf319$var$wishlistArray.includes(game.id));
    $2b6e161c9edcf319$var$renderWishlistGames(wishlistedGames);
    // search.value = "";
    if ($2b6e161c9edcf319$var$wishlistArray.length === 0) {
        $2b6e161c9edcf319$var$catDiv.removeChild(wrapper);
        setTimeout(()=>{
            $2b6e161c9edcf319$var$wishlistBtn.classList.remove("active-2");
            $2b6e161c9edcf319$var$homeBtn.classList.add("active-2");
            $2b6e161c9edcf319$var$catBtn.forEach((btn)=>{
                btn.classList.remove("active");
            });
            $2b6e161c9edcf319$var$catBtn[0]?.classList.add("active");
            $2b6e161c9edcf319$var$renderGames((0, $6ce733342529a65e$export$79863f625c4e57));
            $2b6e161c9edcf319$var$catDivInner.classList.remove("hidden");
        }, 3000);
    }
}
$2b6e161c9edcf319$var$wishlistBtn.addEventListener("click", $2b6e161c9edcf319$var$showWishlist);
//
$2b6e161c9edcf319$var$recommendationsBtn.addEventListener("click", (e)=>{
    // search.value = "";
    if ($2b6e161c9edcf319$var$recommendationsBtn.classList.contains("active-2")) {
        $2b6e161c9edcf319$var$recommendationsBtn.classList.remove("active-2");
        $2b6e161c9edcf319$var$recommendModal.classList.add("hidden");
        // homeBtn.classList.add("active-2");
        // renderGames(games);
        return;
    }
    $2b6e161c9edcf319$var$homeBtn.classList.remove("active-2");
    $2b6e161c9edcf319$var$wishlistBtn.classList.remove("active-2");
    $2b6e161c9edcf319$var$recommendationsBtn.classList.add("active-2");
    // if(e.target.classList.contains){
    // }
    const recomGames = (0, $6ce733342529a65e$export$79863f625c4e57).filter((g)=>g.type.includes("fav")).slice(0, 4);
    $2b6e161c9edcf319$var$recommendModal.innerHTML = "";
    recomGames.forEach((game)=>{
        const card = document.createElement("div");
        card.className = "mini-game-card";
        // card.style.padding = "10px";
        card.innerHTML = `
            <img src="${game.img}" alt="${game.title}" style=" height:140px; object-fit:cover; border-radius:5px;">
            <p style="color:white; font-size:18px; text-align:center;">${game.title}</p>
            `;
        $2b6e161c9edcf319$var$recommendModal.appendChild(card);
    });
    $2b6e161c9edcf319$var$recommendModal.classList.remove("hidden");
});
//////////////////////////////////////////////////
/////////////////////////////////////////////////
// game view details logic + video play.
$2b6e161c9edcf319$var$parent.addEventListener("click", (e)=>{
    if (e.target.classList.contains("card-p-view")) {
        const card = e.target.closest(".home-div-2");
        const details1 = card.querySelector(".game-details");
        const video = details1.querySelector(".modal-video");
        document.querySelectorAll(".game-details.show").forEach((d)=>{
            if (d !== details1) {
                const v = d.querySelector(".modal-video");
                v.pause();
                v.src = "";
                d.classList.remove("show");
                d.classList.add("hidden");
            }
        });
        details1.classList.remove("hidden");
        requestAnimationFrame(()=>details1.classList.add("show"));
        const id = Number(card.dataset.id);
        const game = (0, $6ce733342529a65e$export$79863f625c4e57).find((g)=>g.id === id);
        video.src = game.video;
        video.currentTime = 0;
        video.play();
    }
    if (e.target.classList.contains("details-close")) {
        const details2 = e.target.closest(".game-details");
        const video = details2.querySelector(".modal-video");
        details2.classList.remove("show");
        video.pause();
        video.src = "";
        setTimeout(()=>{
            details2.classList.add("hidden");
        }, 400);
    }
});
////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//     parent.addEventListener("click", (e) => {
//     if (!e.target.classList.contains("card-p-view")) return;
//     const card = e.target.closest(".home-div-2");
//     const id = Number(card.dataset.id);
//     const game = games.find(g => g.id === id);
//     openGameModal(game);
//     });
//     //
//     const modal = document.querySelector(".game-modal");
//     const video = modal.querySelector(".modal-video");
//     function openGameModal(game) {
//     modal.classList.remove("hidden");
//     video.src = game.video;
//     video.currentTime = 0;
//     video.play();
//     modal.querySelector(".modal-title").textContent = game.title;
//     // modal.querySelector(".modal-price").textContent = `₹ ${game.price}`;
//     // modal.querySelector(".modal-rating").textContent = getRating(game.ratings);
//     }
//     //
//     modal.addEventListener("click", (e) => {
//     if (
//         e.target.classList.contains("game-modal") ||
//         e.target.classList.contains("modal-close")
//     ) {
//         closeModal();
//     }
//     });
//     function closeModal() {
//     video.pause();
//     video.src = "";
//     modal.classList.add("hidden");
// }
/////////////////////////////////////////////////////
////////////////////////////////////////////////////
//     parent.addEventListener("click", (e) => {
//     if (!e.target.classList.contains("card-p-view")) return;
//     const card = e.target.closest(".home-div-2");
//     const id = Number(card.dataset.id);
//     const game = games.find(g => g.id === id);
//     openGameModal(game);
//     });
//     //
//     const modal = document.querySelector(".game-modal");
//     const video = modal.querySelector(".modal-video");
//     function openGameModal(game) {
//     modal.classList.remove("hidden");
//     video.src = game.video;
//     video.currentTime = 0;
//     video.play();
//     // modal.querySelector(".modal-title").textContent = game.title;
//     // modal.querySelector(".modal-price").textContent = `₹ ${game.price}`;
//     // modal.querySelector(".modal-rating").textContent = getRating(game.ratings);
//     }
//     //
//     modal.addEventListener("click", (e) => {
//     if (
//         e.target.classList.contains("game-modal") ||
//         e.target.classList.contains("modal-close")
//     ) {
//         closeModal();
//     }
//     });
//     function closeModal() {
//     video.pause();
//     video.src = "";
//     modal.classList.add("hidden");
// }
///////////////////////////////////////////////////////////////
const $2b6e161c9edcf319$var$footerYear = document.querySelector(".footer-year");
$2b6e161c9edcf319$var$footerYear.textContent = new Date().getFullYear(); ///////////////////////////////////////////////////////////////


//# sourceMappingURL=path0.b7587314.js.map
